import React from 'react';
import { Circles } from 'react-loader-spinner';

const LoadingSpinner = () => {
  return (
    <div className="spinner">
      <Circles
        height="100"
        width="100"
        color="blue"
        ariaLabel="loading"
      />
    </div>
  );
};

export default LoadingSpinner;